// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"f8f102a9","151":"bbe55817","271":"57062145","545":"904bb6b8","828":"38767d55","985":"e61dfe87"}[chunkId] + ".chunk.js";
};